module.exports = __webpack_public_path__ + "static/gobierno_spain-2de7354f2f21b313e9e741c5b283a3c7.png";